import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { User, UserService } from 'src/app/core';
@Component({
  selector: 'app-notfound',
  templateUrl: './app.notfoundco.component.html',
})
export class AppNotfoundCoComponent {
    
    currentUser: User;
    isAuthenticated: boolean;
    
    constructor(private router: Router,
        private userService: UserService) {
            
        //Deben cargarse los partes que correspondan a la jerarquía hacia abajo
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
        });    
    }

    salir(){
        this.userService.purgeAuth();
        this.router.navigateByUrl('');
    }
}
